const interactions = (state = null, action) => {
  switch (action.type) {
    case 'SET_INTERACTIONS':
      return action.interactions;
    default:
      return state;
  }
};

export default interactions;
